{
  "background": {
    "background-default": "#050709",
    "background-subtle": "#0e1113"
  },
  "surface": {
    "surface-default": "#0e1113",
    "surface-raised": "#22272b",
    "surface-sunken": "#050709"
  },
  "text": {
    "text-default": "#f5f5f5",
    "text-muted": "#cdd3d6",
    "text-subtle": "#888f92",
    "text-inverse": "#050709",
    "text-link": "#8ce0ff"
  },
  "border": {
    "border-default": "#353b3f",
    "border-subtle": "#22272b",
    "border-strong": "#888f92"
  },
  "action": {
    "action-default": "#26aeff",
    "action-hover": "#8ce0ff",
    "action-subtle": "#001037"
  },
  "success": {
    "success-surface": "#001600",
    "success-text": "#8fc78a",
    "success-border": "#005a02",
    "success-solid": "#399936"
  },
  "warning": {
    "warning-surface": "#270400",
    "warning-text": "#eea88a",
    "warning-border": "#882f03",
    "warning-solid": "#d36734"
  },
  "danger": {
    "danger-surface": "#230002",
    "danger-text": "#ea9294",
    "danger-border": "#7c061f",
    "danger-solid": "#c63f4e"
  },
  "info": {
    "info-surface": "#02071c",
    "info-text": "#8098c2",
    "info-border": "#193366",
    "info-solid": "#4264a4"
  }
}
